
















import { isDark } from '@bkwld/light-or-dark'
import { getColorNameFromHex } from 'library/helpers/ui'
export default

	props: block: Object

	# Get the index of the block
	inject: blockIndex: default: 0

	# Provide the wrapper's background color to child components
	provide: -> backgroundColor: @backgroundColorName

	computed:

		# Make the backgroundColor, which may not contain a leading '#'
		# https://github.com/presseddigital/colorit/pull/35
		backgroundColor: ->
			return unless color = @block.backgroundColor
			return if color == 'transparent'
			if color.match(/^(\#|rgb)/i) then color else '#' + color

		# Look up color name (ie. 'light-green') from @backgroundColor hex
		backgroundColorName: -> getColorNameFromHex @backgroundColor

		# Is it a dark background color
		isDark: -> isDark @backgroundColor if @backgroundColor

		# Root classes
		classes: -> [
			if @isDark then 'fg-light' else 'fg-dark'
			"bg-#{@backgroundColorName}"
			'test-variant' if @block.testVariant
		]

